import { render, staticRenderFns } from "./tag-select.vue?vue&type=template&id=52528f0c&scoped=true"
import script from "./tag-select.vue?vue&type=script&lang=js"
export * from "./tag-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52528f0c",
  null
  
)

export default component.exports